import { __decorate, __metadata } from "tslib";
import { lazyAppContextConsumer } from '@1inch-community/core/lazy';
import { subscribe, translate } from '@1inch-community/core/lit-utils';
import '@1inch-community/ui-components/icon';
import '@1inch-community/ui-components/scroll';
import { html, LitElement } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { map } from 'lit/directives/map.js';
import { tap } from 'rxjs';
import '../wallet-view';
import { walletListStyle } from './wallet-list.style';
let WalletListElement = class WalletListElement extends LitElement {
    constructor() {
        super(...arguments);
        this.applicationContext = lazyAppContextConsumer(this);
    }
    static { this.tagName = 'inch-wallet-list'; }
    static { this.styles = walletListStyle; }
    firstUpdated() {
        subscribe(this, this.getController().supportedWallets$.pipe(tap((adapters) => (this.adapters = adapters))), { requestUpdate: false });
    }
    getAgreementsView() {
        return html `
      <div class="agreements">
        ${translate('widgets.wallet-list.agreements-main')}
        <span class="agreements-link">${translate('widgets.wallet-list.agreements-terms')}</span>
        ${translate('widgets.wallet-list.agreements-and')}
        <span class="agreements-link">${translate('widgets.wallet-list.agreements-privacy')}</span>
      </div>
    `;
    }
    render() {
        return !this.adapters
            ? html ` <inch-icon icon="unicornRun"></inch-icon>`
            : html `
          <inch-scroll-view-consumer>
            <div class="container">
              ${map(this.adapters, (info) => html ` <inch-wallet-view .info="${info}"></inch-wallet-view>`)}
              ${this.getAgreementsView()}
            </div>
          </inch-scroll-view-consumer>
        `;
    }
    getController() {
        return this.applicationContext.value.wallet;
    }
};
__decorate([
    state(),
    __metadata("design:type", Array)
], WalletListElement.prototype, "adapters", void 0);
WalletListElement = __decorate([
    customElement(WalletListElement.tagName)
], WalletListElement);
export { WalletListElement };
//# sourceMappingURL=wallet-list.element.js.map